import type { TFunction } from 'i18next'

import {
  dx7BankArchiveMaximumBanks,
  Dx7BankFileError,
  dx7BankFileSize,
  Dx7CatalogBankUnavailableError,
} from '@/lib/dx7'
import { WorkspaceBankUnavailableError } from '@/lib/patch-library'

/**
 * Explains a failed bank operation in the interface language. Library errors a user can act on get
 * their own message; anything else shows the operation's fallback rather than technical text.
 */
export function bankErrorMessage(t: TFunction, error: unknown, fallback: string) {
  if (error instanceof Dx7BankFileError) {
    switch (error.problem) {
      // Either way the file was spoiled somewhere, and fetching it again is the remedy.
      case 'checksum':
      case 'high-bit-data':
        return t('banks.fileErrors.damaged')
      case 'format':
        return t('banks.fileErrors.format')
      case 'size':
        return t('banks.fileErrors.size', {
          bytes: error.receivedBytes,
          expected: dx7BankFileSize,
        })
      case 'too-large':
        return t('banks.fileErrors.tooLarge', { count: dx7BankArchiveMaximumBanks })
    }
  }
  if (error instanceof Dx7CatalogBankUnavailableError) return t('banks.catalogUnavailable')
  if (error instanceof WorkspaceBankUnavailableError) return t('banks.bankUnavailable')
  return fallback
}
